<div class="table-container">
  <!-- Header con filtros -->
  <div class="table-header" *ngIf="config?.filtering?.enabled">
    <div class="table-controls">
      <div class="page-size-selector">
        <label>Mostrar</label>
        <select [(ngModel)]="pageSize" (change)="onPageSizeChange()" class="page-size-select">
          <option *ngFor="let option of pageSizeOptions" [value]="option">{{option}}</option>
        </select>
        <label>registros</label>
      </div>
    </div>

    <div class="search-container">
      <input type="text" class="search-input" [(ngModel)]="searchTerm" (input)="onSearch()"
        [placeholder]="config.filtering?.placeholder || 'Buscar...'">
      <div class="search-icon">
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M21 21L16.514 16.506L21 21ZM19 10.5C19 15.194 15.194 19 10.5 19C5.806 19 2 15.194 2 10.5C2 5.806 5.806 2 10.5 2C15.194 2 19 5.806 19 10.5Z"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </div>
    </div>
  </div>

  <!-- Tabla -->
  <div class="table-wrapper">
    <table class="dynamic-table">
      <thead>
        <tr>
          <th *ngFor="let column of config?.columns" [class.sortable]="column.sortable" [style.width]="column.width"
            (click)="onSort(column)" [ngClass]="column.isHidden ? 'hidden':''">
            <div class="th-content">
              <span>{{ column.title }}</span>
              <div class="sort-icons" *ngIf="column.sortable">
                <svg class="sort-icon" [class.active]="sortColumn === column.key && sortDirection === 'asc'" width="8"
                  height="6" viewBox="0 0 8 6" fill="none">
                  <path d="M4 0L0 6H8L4 0Z" fill="currentColor" />
                </svg>
                <svg class="sort-icon" [class.active]="sortColumn === column.key && sortDirection === 'desc'" width="8"
                  height="6" viewBox="0 0 8 6" fill="none">
                  <path d="M4 6L8 0H0L4 6Z" fill="currentColor" />
                </svg>
              </div>
            </div>
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let item of paginatedData; let i = index" [class.even]="i % 2 === 0">
          <ng-container *ngFor="let column of config?.columns">
            <td [ngClass]="column.isHidden ? 'hidden' : ''">

              <span *ngIf="column.isHidden" [ngClass]="column.isHidden ? 'hidden' : ''">
                {{ getCellValue(item, column) }}
              </span>

              <span *ngIf="column.type === 'text'" class="cell-text">
                {{ getCellValue(item, column) }}
              </span>

              <span *ngIf="column.type === 'time'" class="time-text">
                <mat-icon>query_builder</mat-icon>
                <p>{{ getCellValue(item, column) | msDuration:'s' }}</p>
              </span>

              <span *ngIf="column.type === 'icon'" class="icon-cell">
                <mat-icon>{{ column.icon }}</mat-icon>
                <p>{{ getCellValue(item, column) }}</p>
              </span>

              <app-so-badge *ngIf="column.type === 'badge-circle' && column?.click === true" [isCircle]="true"
                [class]="getBadgeClass(getCellValue(item, column), column)" [text]="getCellValue(item, column)"
                (click)="column?.click && onButtonClick(column.buttonConfig?.action || '', item)" [ngStyle]="{
          'cursor': column?.click && getCellValue(item, column) > 0
            ? 'pointer'
            : 'not-allowed'
        }">
              </app-so-badge>

              <span *ngIf="column.type === 'badge'" class="badge"
                [ngClass]="getBadgeClass(getCellValue(item, column), column)">
                <span *ngIf="getBadgeClass(getCellValue(item, column), column).includes('status-')">
                </span>
                <span *ngIf="!getBadgeClass(getCellValue(item, column), column).includes('status-')">
                  {{ getCellValue(item, column) }}
                </span>
              </span>

              <button *ngIf="column.type === 'button'" class="btn" [ngClass]="getButtonClass(column)"
                (click)="onButtonClick(column.buttonConfig?.action || '', item)">
                {{ column.buttonConfig?.text || 'Acción' }}
              </button>

              <a *ngIf="column.type === 'link'" class="cell-link" [href]="getCellValue(item, column)"
                [target]="column.linkConfig?.target || '_self'" (click)="onLinkClick(item)">
                {{ getCellValue(item, column) }}
              </a>

              <img *ngIf="column.type === 'image'" class="cell-image" [src]="getCellValue(item, column)"
                [alt]="column.imageConfig?.alt || ''" [style.width]="column.imageConfig?.width || '40px'"
                [style.height]="column.imageConfig?.height || '40px'">

              <span *ngIf="column.type === 'date'" class="cell-date">
                {{ formatDate(getCellValue(item, column)) }}
              </span>

              <span *ngIf="column.type === 'number'" class="cell-number">
                {{ getCellValue(item, column) | number }}
              </span>

            </td>
          </ng-container>
        </tr>

      </tbody>
    </table>
  </div>

  <!-- Paginación -->
  <div class="pagination-container" *ngIf="config?.pagination?.enabled">
    <div class="pagination-info">
      <span>
        Mostrando registros del {{ paginationInfo.startIndex + 1 }} al {{ paginationInfo.endIndex }}
        de un total de {{ paginationInfo.totalItems }} registros
      </span>
    </div>

    <div class="pagination-controls">
      <button class="pagination-btn" [disabled]="currentPage === 1" (click)="onPageChange(currentPage - 1)">
        Anterior
      </button>

      <button *ngFor="let page of getPageNumbers()" class="pagination-btn" [class.active]="page === currentPage"
        (click)="onPageChange(page)">
        {{ page }}
      </button>

      <button class="pagination-btn" [disabled]="currentPage === paginationInfo.totalPages"
        (click)="onPageChange(currentPage + 1)">
        Siguiente
      </button>
    </div>
  </div>
</div>
